import React from "react";
import {parseTitle} from "./pageModel";
import {buildNewsImageUrl} from "../utils";

// Textes personnalisables des rubriques de la landing. Une rubrique sans texte personnalisé (data vide)
// affiche son texte d'origine : chaque aide prend ce texte en repli. Tout est rendu comme du TEXTE par
// React (jamais de HTML interprété) ; les liens sont revalidés ici même si le serveur les a déjà validés.

export function text(data, key, fallback) {
    const value = data ? data[key] : undefined;
    return typeof value === "string" && value !== "" ? value : fallback;
}

export function listOf(data, key, fallback) {
    const value = data ? data[key] : undefined;
    return Array.isArray(value) && value.length > 0 ? value : fallback;
}

// Lien interne (/chemin) ou https:// uniquement ; tout le reste (javascript:, data:, //hôte, /\hôte, http:) retombe sur le repli.
export function safeUrl(value, fallback) {
    return typeof value === "string" && /^(\/(?![/\\])|https:\/\/)\S*$/.test(value) ? value : fallback;
}

// Chemin interne uniquement (/…) : pour les images chargées d'office, jamais de ressource tierce (même dans une
// ancienne version restaurée qui contiendrait encore une adresse https://).
export function safeInternalUrl(value, fallback) {
    return typeof value === "string" && /^\/(?![/\\])\S*$/.test(value) ? value : fallback;
}

export function youtubeIdOf(value, fallback) {
    return typeof value === "string" && /^[\w-]{6,40}$/.test(value) ? value : fallback;
}

// Titre avec mot(s) entre accolades mis en valeur : « Donnez votre avis, {pas} seulement ».
export function TitleText({value, fallback, accentTag = "span"}) {
    const Accent = accentTag;
    const source = typeof value === "string" && value !== "" ? value : fallback;
    return parseTitle(source).map((part, i) => (
        part.accent
            ? <Accent key={i} className={accentTag === "span" ? "accent" : undefined}>{part.text}</Accent>
            : <React.Fragment key={i}>{part.text}</React.Fragment>
    ));
}

// Texte avec passages en gras entre ** : « Cliquez sur **« Accéder au réseau »** en haut ».
export function InlineText({value, fallback}) {
    const source = typeof value === "string" && value !== "" ? value : fallback;
    return source.split(/\*\*([^*]+)\*\*/).map((chunk, i) => (
        i % 2 === 1 ? <strong key={i}>{chunk}</strong> : <React.Fragment key={i}>{chunk}</React.Fragment>
    ));
}

// Image téléversée depuis l'Admin (/uploads/landing/<32 hex>.webp) : URL complète vers l'API, ou null si la valeur n'est pas
// exactement un fichier téléversé (aucune image externe, aucun schéma javascript:/data:).
export function uploadedImageUrl(value) {
    return typeof value === "string" && /^\/uploads\/landing\/[0-9a-f]{32}\.webp$/.test(value) ? buildNewsImageUrl(value) : null;
}
